import React from 'react';

import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import { FONTSIZE_XS } from 'theme/typography';
import globalMessages from 'translations/messages/global-messages';

export const styles = theme => ({
  label: {
    color: `${theme.palette.info.main}`,
    backgroundColor: `${theme.palette.info.main}1A`,
    borderRadius: 4,
    padding: '0.250rem',
    fontSize: FONTSIZE_XS,
    marginLeft: 'auto',
  },
});

export function NewTag({ classes, intl }) {
  return (
    <Typography
      classes={{
        root: classes.label,
      }}
    >
      {intl.formatMessage(globalMessages.new)}
    </Typography>
  );
}

NewTag.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default compose(injectIntl, withStyles(styles))(NewTag);
